export default function About() {
  const principles = [
    { icon: "ri-scales-3-line", title: "来源优先", desc: "尽量标注信源，引述公开物料与官方声明，不替网友下结论。" },
    { icon: "ri-eye-2-line", title: "理性吃瓜", desc: "复盘讲清经过与争议双方，不渲染情绪、不恶意带节奏。" },
    { icon: "ri-time-line", title: "准时收摊", desc: "每晚 22:00 出晚间汇总，白天碎片瓜留到晚上一次收齐。" },
    { icon: "ri-chat-check-line", title: "有错就改", desc: "收到更正反馈会及时复查信源，偏差内容一律更正或下架。" },
  ];

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-quill-pen-line"></i> 关于吃瓜今日
            </p>
            <h2 className="serif-title mt-2 text-3xl font-black leading-snug text-foreground-950 md:text-4xl">
              把一天的瓜田，
              <br className="hidden md:block" />
              收进<span className="text-primary-600">一碗晚饭</span>里
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              吃瓜今日是一份面向泛娱乐网民的“晚间瓜田日报”。我们不做追星站队，也不贩卖焦虑，只把今天综艺、影视、音乐、红毯、电竞与圈内的看点，按时间线规整成一份清清楚楚的收尾盘点。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              白天没空刷热搜没关系，晚上的瓜田晚报会帮你补全经过、后续与争议点，让你睡前快速收摊，安心睡个好觉。
            </p>
            <div className="mt-7 flex flex-wrap gap-4">
              <div className="rounded-2xl border border-background-200 bg-background-100 px-6 py-4">
                <p className="serif-title text-3xl font-black text-primary-600">每晚</p>
                <p className="mt-1 text-xs text-foreground-500">22:00 准时更新</p>
              </div>
              <div className="rounded-2xl border border-background-200 bg-background-100 px-6 py-4">
                <p className="serif-title text-3xl font-black text-accent-600">6 大</p>
                <p className="mt-1 text-xs text-foreground-500">吃瓜频道覆盖</p>
              </div>
              <div className="rounded-2xl border border-background-200 bg-background-100 px-6 py-4">
                <p className="serif-title text-3xl font-black text-secondary-600">0 门槛</p>
                <p className="mt-1 text-xs text-foreground-500">免费阅读无需登录</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <h3 className="serif-title mt-4 text-lg font-bold text-foreground-900">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}